import { IToken } from 'shared/models/Altenar'

export class AltenarConverter {
  convertToken(data: IToken): string {
    return data.token
  }
}